import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../api/api";

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState(null);
  const [err, setErr] = useState(null);

  const handle = async (e) => {
    e.preventDefault();
    try {
      const res = await api.request(`/auth/reset-password/${token}`, {
        method: "POST",
        body: JSON.stringify({ password }),
      });
      setMsg(res.message);
      setErr(null);
      setTimeout(() => navigate("/login"), 1500);
    } catch (e) {
      setErr(e.message || "Failed to reset password");
      setMsg(null);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-zinc-900/80 p-8 rounded-xl border border-zinc-700">

        <h2 className="text-2xl text-yellow-400 font-bold text-center mb-4 uppercase">
          New Password
        </h2>

        {msg && <p className="text-green-400 text-sm">{msg}</p>}
        {err && <p className="text-red-500 text-sm">{err}</p>}

        <form onSubmit={handle} className="space-y-4">
          <input
            type="password"
            className="w-full px-4 py-3 bg-zinc-800 text-white border border-zinc-700 rounded"
            placeholder="New password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <button className="w-full py-3 bg-yellow-500 hover:bg-yellow-600 text-black rounded">
            Change Password
          </button>
        </form>

      </div>
    </div>
  );
}
